import type { ISpRewardBrand } from '@brushfire/types'
import { formatUsd } from './profileStepUtils'
import { resolveEffectiveMinUsd } from './rewards-config'

/**
 * Catalog-fixed denomination (min === max on the Tremendous product),
 * not a variable brand whose redeemable window was squeezed to the user's balance.
 */
export function isFixedRedemptionAmount(brand: ISpRewardBrand): boolean {
  const catalogMin = brand.catalogMinAmountUsd ?? brand.minAmountUsd
  const catalogMax = brand.catalogMaxAmountUsd ?? brand.maxAmountUsd
  if (catalogMin === catalogMax) {
    return true
  }
  return (
    brand.allowedAmountsUsd?.length === 1 &&
    brand.catalogMinAmountUsd == null &&
    brand.catalogMaxAmountUsd == null &&
    brand.allowedAmountsUsd[0] === brand.minAmountUsd
  )
}

/** Figma 5181:10123 — variable-amount brands show min · max under the amount field. */
export function buildVariableAmountHintText(brand: ISpRewardBrand): string {
  const effectiveMinUsd = resolveEffectiveMinUsd(brand.minAmountUsd)
  const catalogMaxUsd = brand.catalogMaxAmountUsd ?? brand.maxAmountUsd
  const minPart = `Minimum ${formatUsd(effectiveMinUsd)}`
  if (catalogMaxUsd <= effectiveMinUsd) {
    return minPart
  }
  return `${minPart} · Maximum ${formatUsd(catalogMaxUsd)} for this brand`
}
